module.exports = __webpack_public_path__ + "img/avatar_blank_dark.740b7795.png";